import React from 'react';
import { graphql } from 'gatsby';
import App from '../components/App';

interface nodeProps {
  id: string;
  html: string;
  frontmatter: {
    lang: string;
    title: string;
    description: string;
    thumbnail: any;
    song: {
      title: string;
      image: any;
      imageAlt: string;
      url: string;
    };
  };
}

interface IndexPageProps {
  data: {
    allMarkdownRemark: {
      nodes: Array<nodeProps>;
    };
  };
}

const IndexPage = ({ data }: IndexPageProps) => {
  return data.allMarkdownRemark.nodes.map((node: nodeProps) => {
    if (node.frontmatter.lang === process.env.GATSBY_SITE_LANG) {
      return <App node={node} />;
    }
  });
};

export const query = graphql`
  {
    allMarkdownRemark(
      filter: { fileAbsolutePath: { regex: "/index.md/" } }
    ) {
      nodes {
        id
        html
        frontmatter {
          lang
          title
          description
          thumbnail {
            childImageSharp {
              original {
                src
              }
            }
          }
          song {
            title
            image {
              childImageSharp {
                gatsbyImageData(width: 350, height: 350, quality: 90)
              }
            }
            imageAlt
            url
          }
        }
      }
    }
  }
`;

export default IndexPage;
